var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mb-3" },
    [
      _c(
        "custom-callout",
        {
          attrs: {
            "border-color": _vm.data.status.color,
            controlled: "",
            "has-toggle": "",
            opened: _vm.data.opened
          },
          on: { "click:open": _vm.open },
          scopedSlots: _vm._u([
            {
              key: "edition",
              fn: function() {
                return [
                  _c("div", { staticClass: "p-2 bg-gray" }, [
                    _c(
                      "div",
                      { staticClass: "p-3 bg-white" },
                      [
                        _vm.showDeterminate
                          ? _c("determinate", {
                              attrs: {
                                id: _vm.data.id,
                                categories: _vm.determinationTypes
                              },
                              on: {
                                close: _vm.closeDeterminate,
                                saved: _vm.onDeterminated
                              }
                            })
                          : _vm.canSeeDetermination
                          ? _c("determination", {
                              attrs: { item: _vm.data },
                              on: { close: _vm.closeDetermination }
                            })
                          : _vm.canSeeHistory
                          ? _c("history", { attrs: { item: _vm.data } })
                          : _c(
                              "custom-tab",
                              {
                                attrs: {
                                  "content-class": "mt-3",
                                  "nav-class":
                                    "nav-vue-underline psf-custom-tab",
                                  "no-nav-style": true
                                }
                              },
                              [
                                _c(
                                  "custom-tab-item",
                                  {
                                    staticClass: "mt-2",
                                    attrs: { title: "Información Adicional" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "row mx-0 mt-4 px-2 mb-3"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-6 col-md-3 mb-2 mb-md-0 d-flex flex-column"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "color-gray-6 d-block font-14"
                                              },
                                              [_vm._v(" Área: ")]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "font-16 color-black font-weight-bold"
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f("empty")(
                                                        _vm.data.area?.name
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-6 col-md-3 mb-2 mb-md-0 d-flex flex-column"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "color-gray-6 d-block font-14"
                                              },
                                              [_vm._v(" Servicio a Ofrecer: ")]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "font-16 color-black font-weight-bold"
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f("empty")(
                                                        _vm.data.service?.name
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-6 col-md-3 mb-2 mb-md-0 d-flex flex-column"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "color-gray-6 d-block font-14"
                                              },
                                              [_vm._v(" Usuario Solicitante: ")]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "font-16 color-black font-weight-bold"
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f("empty")(
                                                        _vm.data.createdBy?.name
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                      ],
                      1
                    )
                  ])
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("div", { staticClass: "row py-2 mr-md-0 n-ml" }, [
            _c(
              "div",
              { staticClass: "col-12 col-md text-center border-right" },
              [
                _c(
                  "div",
                  {
                    class: `badge badge-pill font-16 mt-3 py-2 mx-auto color-black`,
                    style: { "background-color": _vm.data.status.color }
                  },
                  [_vm._v(" " + _vm._s(_vm.data.status.name) + " ")]
                ),
                _c("div", [
                  _c("span", { staticClass: "font-16 color-black" }, [
                    _vm._v(" " + _vm._s(_vm._f("empty")(_vm.data.number)) + " ")
                  ])
                ])
              ]
            ),
            _c("div", { staticClass: "col-12 col-md-10" }, [
              _c("div", { staticClass: "row pt-2" }, [
                _c("div", { staticClass: "col-12 col-md custom-pl" }, [
                  _c("div", { staticClass: "d-flex flex-column" }, [
                    _c(
                      "span",
                      { staticClass: "color-gray-6 d-block font-14" },
                      [_vm._v(" Año Fiscal: ")]
                    ),
                    _c(
                      "span",
                      { staticClass: "font-16 color-black font-weight-bold" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("empty")(_vm.data.academicYear.name)
                            ) +
                            " "
                        )
                      ]
                    )
                  ])
                ]),
                _c("div", { staticClass: "col-12 col-md custom-pl" }, [
                  _c("div", { staticClass: "d-flex flex-column" }, [
                    _c(
                      "span",
                      { staticClass: "color-gray-6 d-block font-14" },
                      [_vm._v(" Fecha de Solicitud: ")]
                    ),
                    _c(
                      "span",
                      { staticClass: "font-16 color-black font-weight-bold" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm._f("date")(_vm.data.requestDate)) +
                            " "
                        )
                      ]
                    )
                  ])
                ]),
                _c("div", { staticClass: "col-12 col-md custom-pl" }, [
                  _c("div", { staticClass: "d-flex flex-column" }, [
                    _c(
                      "span",
                      { staticClass: "color-gray-6 d-block font-14" },
                      [_vm._v(" Tipo de Contratación: ")]
                    ),
                    _c(
                      "span",
                      { staticClass: "font-16 color-black font-weight-bold" },
                      [_vm._v(" " + _vm._s(_vm.data.contractType.name) + " ")]
                    )
                  ])
                ]),
                _c("div", { staticClass: "col-12 col-md custom-pl" }, [
                  _c("div", { staticClass: "d-flex flex-column" }, [
                    _c(
                      "span",
                      { staticClass: "color-gray-6 d-block font-14" },
                      [_vm._v(" Nombre: ")]
                    ),
                    _c(
                      "span",
                      { staticClass: "font-16 color-black font-weight-bold" },
                      [
                        _vm._v(
                          " " + _vm._s(_vm._f("empty")(_vm.data.name)) + " "
                        )
                      ]
                    )
                  ])
                ]),
                _c(
                  "div",
                  { staticClass: "col-12 col-md custom-pl text-md-center" },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c("dropdown", {
                          staticClass: "actions-dropdown",
                          attrs: { items: _vm.actionItems, title: "Acciones" }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ])
          ])
        ]
      ),
      _vm.comment.show
        ? _c("div", { staticClass: "bg-secondary-3 rounded" }, [
            _c("div", { staticClass: "p-2" }, [
              _c(
                "div",
                { staticClass: "p-3 bg-white" },
                [
                  _c("icon-view", {
                    staticClass: "mt-5 mb-3 mt-md-0 mt-sm-5",
                    attrs: {
                      icon: `mb-1 ${_vm.comment.icon}`,
                      "icon-color": _vm.comment.iconColor,
                      "icon-size": "16px",
                      title: _vm.comment.title
                    }
                  }),
                  _c(
                    "validation-observer",
                    { ref: "commentForm", attrs: { novalidate: "" } },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-text-area", {
                                    attrs: {
                                      "count-classes": [
                                        "d-block",
                                        "small-counter"
                                      ],
                                      "custom-error-msg":
                                        "El campo es requerido.",
                                      error: errors[0],
                                      label: "Comentario:",
                                      maxlength: 3000
                                    },
                                    model: {
                                      value: _vm.comment.model.comment,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.comment.model,
                                          "comment",
                                          $$v
                                        )
                                      },
                                      expression: "comment.model.comment"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          855566646
                        )
                      }),
                      _c(
                        "div",
                        { staticClass: "mt-3 bg-secondary-3 p-3 rounded" },
                        [
                          _c("div", { staticClass: "data-name mb-2" }, [
                            _vm._v(" Archivo: ")
                          ]),
                          _c("custom-file-input", {
                            ref: "commentFileUpload",
                            attrs: {
                              accept: ".pdf",
                              "display-style": "normal",
                              "on-download": () => {}
                            },
                            model: {
                              value: _vm.comment.model.file,
                              callback: function($$v) {
                                _vm.$set(_vm.comment.model, "file", $$v)
                              },
                              expression: "comment.model.file"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-end align-items-center mt-4"
                        },
                        [
                          _c("action-button", {
                            attrs: {
                              i: "fas fa-times-circle",
                              text: "Cancelar",
                              variant: "outline-danger mr-2"
                            },
                            on: { click: _vm.cancelComment }
                          }),
                          _c("action-button", {
                            attrs: {
                              i: "fas fa-save",
                              text: "Guardar",
                              variant: "success"
                            },
                            on: {
                              click: function($event) {
                                return _vm.changeStatus()
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }